import { render, staticRenderFns } from "./dialog-is-order-disabled-update.vue?vue&type=template&id=54674938&"
import script from "./dialog-is-order-disabled-update.vue?vue&type=script&lang=js&"
export * from "./dialog-is-order-disabled-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports